<template>
  <div>
      <section class="bar  no-mb a" style="  background-color: #fbfbfb;     ">
        <h2 class="text-uppercase" style="padding-top: 20px;">产品分类</h2>
        <div class="container ">
          <div class="row showcase text-center   ">
            <div class="col-md-3  ">
              <div class="item">
                <div class="icon-outlined   icon-thin"><el-icon size="30px"><Filter /></el-icon></div>
                <h4 > <br>抗肿瘤药</h4>
              </div>
            </div>
            <div class="col-md-3  ">
              <div class="item">
                <div class="icon-outlined   icon-thin"><el-icon size="30px"><ColdDrink /></el-icon></div>
                <h4 ><br>消炎药</h4>
              </div>  
            </div>
            <div class="col-md-3  ">
              <div class="item">
                <div class="icon-outlined  icon-thin"><el-icon size="30px"><SwitchFilled /></el-icon></div>
                <h4><br>新陈代谢</h4>
              </div>
            </div>
            <div class="col-md-3  ">
              <div class="item">
                <div class="icon-outlined   icon-thin"><el-icon size="30px"><Share /></el-icon></div>
                <h4><br>神经系统</h4>
              </div>
            </div>
          </div>
        </div>
    </section>
  </div>
</template>
<style scoped>
.col-md-3 {
  padding: 0;
  margin: 0;
} 
.item { 
    padding-top: 100px;
    height: 350px;
    width: 100%;
    margin-left: 0px !important;
    margin: 0;
}
.item:hover {
  background-color: red;
 }
.icon-outlined {
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  display: inline-block;
  font-size: 1.4rem;
  border-radius: 50%;
  border: 2px solid #fff;
  margin-bottom: 20px;
}
.item {
    color: unset !important; 
  border-left: 2px solid #fff;
  margin-left: 25px;
  font-size: 15px;
}
.el-icon {

margin-top:25px;
}
.showcase .icon-outlined {
  border-color: #555;
}

.icon-outlined.icon-thin {
  border-width: 1px;
}
.icon-outlined.icon-sm {
  width: 55px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 1.15rem;
}
 
.h1 {
  color: red;
  font-size: 72px;;
}
</style>
<script>

</script>
